import {takeLatest, call, put, select} from "redux-saga/effects";
import * as actions from "../action.constants";

import {
  deleteContact,
  getContacts,
  sendContactData,
} from "../AsyncActions/contacts.async";
import {saveContactsList} from "../Actions/contacts.actions";
import {getCurrentCustomer} from "../Selectors/customers.selectors";

function* getContactsList(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const currentCustomer = yield select(getCurrentCustomer);
    const response = yield call(getContacts, {customerId: currentCustomer?.id}, pageUrl);
    if (response) {
      yield put(saveContactsList(response?.data));
    }
  } catch (e) {
    return e;
  }
}

function* sendContactDataRequest(action = {}) {
  try {
    const {payload = {}, callback = () => {}} = action;
    const currentCustomer = yield select(getCurrentCustomer);
    const response = yield call(sendContactData, {
      customerId: currentCustomer?.id,
      data: payload,
    });
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* sendDeleteContactRequest(action = {}) {
  try {
    const {payload = "", callback = () => {}} = action;
    const currentCustomer = yield select(getCurrentCustomer);
    const response = yield call(deleteContact, {
      customerId: currentCustomer?.id,
      id: payload,
    });
    if (response) {
      yield callback();
    }
  } catch (e) {
    return e;
  }
}

export function* customersSaga() {
  yield takeLatest(actions.REQUEST_GET_CONTACTS_LIST_SAGA, getContactsList);
  yield takeLatest(actions.REQUEST_SEND_CONTACT_DATA_SAGA, sendContactDataRequest);
  yield takeLatest(actions.REQUEST_DELETE_CONTACT_SAGA, sendDeleteContactRequest);
}
